// ==========================================================================
// Anidub extended configs
// ==========================================================================

import defaults from './defaults';

export default {
    // Extend default configs
    ...defaults,

    // Default time to skip the opening
    openingSeekTime: 85,

    // Buffer
    buffer: {
        type: 1,
        exec: null,
    },

    // Quality
    quality: {
        default: 1080,
        options: [0, 1080, 720, 480, 360, 240, 144],
    },

    // Height
    previewHeight: 100,

    // Controls
    controls: [
        ...defaults.controls,
        'skip-opening',
        'p2p',
    ],

    // Localisation
    i18n: {
        // Extend default i18n
        ...defaults.i18n,
        restart: 'Повторить',
        rewind: 'Назад на {seektime}с',
        play: 'Продолжить (k)',
        pause: 'Пауза (k)',
        fastForward: 'Вперёд на {seektime}с',
        seek: 'Перемотать',
        played: 'Воспроизведено',
        buffered: 'Буферизировано',
        currentTime: 'Текущее время',
        duration: 'Длительность',
        volume: 'Громкость',
        skipOpening: 'Пропустить опенинг',
        mute: 'Отключить звук (m)',
        unmute: 'Включить звук (m)',
        enableCaptions: 'Включить субтитры (c)',
        disableCaptions: 'Отключить субтитры (c)',
        download: 'Скачать',
        enterFullscreen: 'Во весь экран (f)',
        exitFullscreen: 'Выход из полноэкранного режима (f)',
        frameTitle: 'Плеер для {title}',
        captions: 'Субтитры',
        settings: 'Настройки',
        menuBack: 'Вернуться в предыдущее меню',
        speed: 'Скорость',
        normal: 'Нормальная',
        quality: 'Качество',
        loop: 'Повтор',
        start: 'Начать',
        end: 'Конец',
        all: 'Всё',
        p2p: 'P2P',
        auto: 'По умолчанию',
        reset: 'Сбросить',
        disabled: 'Отключено',
        enabled: 'Включено',
        advertisement: 'Реклама',
        adexplanation: 'Ваш бесплатный просмотр спонсируется',
        qualityBadge: {
            ...defaults.i18n.qualityBadge,
            'auto': 'AUTO',
        },
    },

    // Custom control listeners
    listeners: {
        // Extend default configs
        ...defaults.listeners,
        skipOpening: null,
        p2p: null,
    },

    // Events to watch and bubble
    events: [
        // Extend default configs (without ad)
        ...defaults.events.filter(x => x.substr(0, 2) !== 'ad'),

        // Ads
        'adsloaded',
        'adscontentloaded',
        'adstarted',
        'adserror',
        'adsblocked',
        'adscomplete',
    ],

    // Selectors
    // Change these to match your template if using custom HTML
    selectors: {
        // Extend default configs
        ...defaults.selectors,
        buttons: {
            ...defaults.selectors.buttons,
            skipOpening: '[data-plyr="skip-opening"]',
            p2p: '[data-plyr="p2p"]',
        },
    },

    // Ads
    ads: {
        enabled: false,
        timeout: 5000,
        sources: [],
    },

    // Quality
    availableQuality: [],
};
